import StyledImage from './PresentedByLogoStyles';

export interface PresentedByLogoProps {
  src: string;
  width: string;
  height: string;
  altText: string;
}

const PresentedByLogo = (props: PresentedByLogoProps) => {
  const { src, width, height, altText } = props;

  return (
    <StyledImage
      src={src}
      width={width}
      height={height}
      alt={altText}
      sizes='10vw'
    />
  );
};

export default PresentedByLogo;
